const TRIAL_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

export function getTrialInfo(userCreatedAt: string): {
  isTrialActive: boolean;
  daysRemaining: number;
  expiryDate: Date;
} {
  const createdAt = new Date(userCreatedAt).getTime();
  const expiryDate = new Date(createdAt + TRIAL_DURATION_MS);
  const msRemaining = expiryDate.getTime() - Date.now();
  const daysRemaining = Math.max(
    0,
    Math.ceil(msRemaining / (24 * 60 * 60 * 1000)),
  );

  return {
    isTrialActive: msRemaining > 0,
    daysRemaining,
    expiryDate,
  };
}

export function formatPsTokens(value: number): string {
  return Math.trunc(value).toLocaleString('en-US');
}

export function formatExpiryDate(expiry: string | null): string | null {
  if (!expiry) return null;
  const date = new Date(expiry);
  if (date <= new Date()) return 'Expired';
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
